import React, { useState, useEffect, Suspense } from 'react'
import { useForm } from 'react-hook-form';
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom';
import TagsInput from 'react-tagsinput'
import { FileUploader } from "react-drag-drop-files";
import { ReactSession } from 'react-client-session';
import 'react-toastify/dist/ReactToastify.css';
import ProgressBar from 'react-bootstrap/ProgressBar'

import Header from '../../Header/Header';
import Sidebar from '../../Sidebar/Sidebar';
import Loader from '../../Global/Loader';

import styles from '../../../App.module.css';
import classes from './AddMusic.module.css'
import Tabs from '../Tabs/Tabs';
// import TabsList from '../Share/Tabs/Tabs'

import noThumb from "../../../images/no-thumb.jpg";
const fileTypes = ["MP3", "WAV", "AAC", "OGG", "FLAC", "MPEG"];

function AddMusic() {
    const navigate = useNavigate();
    const {register, handleSubmit, formState: { errors }} = useForm();
    const [image, setImage] = useState('');
    const [thumb, setThumb] = useState([]);
    
    const [tags, setTags] = useState([]);
    const [nsfw, setNsfw] = useState(true);
    const [privacy, setPrivacy] = useState(true);

    const [selectedFile, setSelectedFile] = useState(null);
    const [percentage, setPercentage] = useState(0);
    const [form, setForm] = useState(false);
    const [categories, setCategories] = useState([]);
    const [processBar, setProcessBar] = useState(false);
    const [inputValue , setInputValue] = useState('');
    const [ifDisabled, setIfDisabled] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState({
        status: false,
        message: ''
    });
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        !logged_user && navigate('/login');
    } , [])

    const handleChange = (files) => {
        setSelectedFile(files)
    };

    const getCategories = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/categories.php`, {
            type: 2
        },
        {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            setCategories(res.data);
        }).catch(err => {
            console.log(err);
        })
    }

    useEffect(() => {
        selectedFile && setForm(true);
        selectedFile && setInputValue(selectedFile.name);
        getCategories();
    }, [selectedFile])

    const handleChangeTitle = (e) => {
        setInputValue(e.target.value);
    }

    const onImageChange = (e) => {
        setThumb(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setImage('');
        }
    }

    const handleChangeTags = (tags) => {
        setTags(tags);
    }

    const formSubmit = (e) => {
        setIfDisabled(true);

        const data = new FormData();
        data.append('user_id', logged_user);
        data.append('media', 2);
        data.append('selectedFile', selectedFile);
        data.append('play-img', thumb);
        data.append('title', e.title);
        data.append('description', e.description);
        data.append('categ', e.categ);
        data.append('nsfw', nsfw);
        data.append('privacy', privacy);
        data.append('tags', tags);

        setProcessBar(true);

        const config = {
            onUploadProgress: (progressEvent) => {
                const {loaded, total} = progressEvent;
                let percent = Math.floor( (loaded * 100) / total )
                // console.log( `${loaded}kb of ${total}kb | ${percent}%`);

                // console.log(percent);

                if(percent < 100){
                    setPercentage(percent)
                }else if(percent === 100) {
                    setPercentage(100)
                }
            },
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/upload.php`, data, config)
        .then(res => {
            // console.log(res.data);
            setTimeout(() => {
                setPercentage(0)
            }, 3000);

            setProcessBar(false);
            setIsSubmitted({
                status: true,
                type: res.data.status,
                message: res.data.message
            });

            setIfDisabled(false);
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <>
            <Header />
            <div className={styles.main_body}>
            <Suspense fallback="<div>Please wait...</div>">
                <Sidebar />
            </Suspense>
            <Suspense fallback="<div>Please wait...</div>">
                <div className={styles.main_content + ` main-content`}>
                    <div className={`${classes.addMusic_component} addMusic_component p-4`}>
                        <Tabs active="addmusic" />
                        <div className={classes.panel}>
                            <div className={classes.panel_body}>
                                {/* <TabsList active="music" /> */}
                                {/* <div className={classes.uploader}>
                                    <FileUploader handleChange={handleChange} name="file" types={fileTypes} />
                                </div> */}
                                {
                                    processBar && <div className='mt-5 mb-3'>
                                        <ProgressBar animated now={percentage} label={`${percentage}%`} />
                                    </div>
                                }

                                {
                                    !form && <div className={`${classes.uploader} mt-4 pt-2`}>
                                        <FileUploader handleChange={handleChange} name="file" types={fileTypes} />
                                    </div>
                                }

                                {
                                    form && <>
                                        {
                                            !isSubmitted.status ? <div className='row'>
                                                <div className="col-8">
                                                    <form onSubmit={handleSubmit(formSubmit)}>
                                                        <div className="form-group mt-3">
                                                            <label>Title</label>
                                                            <input {...register('title', {required: true})} className='form-control' value={inputValue} onChange={handleChangeTitle} placeholder="Your Music's Title" />
                                                            {errors.title && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                        </div>
                                                        <div className="form-group my-3">
                                                            <label>Description</label>
                                                            <textarea {...register('description')} className="form-control" rows="3" placeholder="Your Music's Description"></textarea>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Category</label>
                                                            <select {...register('categ')} className="form-control">
                                                                <optgroup label="Categories" dangerouslySetInnerHTML={{__html: `${categories}`}} />
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Tags</label>
                                                            <TagsInput value={tags} onChange={handleChangeTags} />
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div className="col-6">
                                                                <label>NSFW</label>
                                                                <div className={`form-group ${classes.radio}`}>
                                                                    <label className="radio d-inline-flex">
                                                                        <input {...register('nsfw')} type="radio" className="styled" value="1" /> <span>Not safe</span>
                                                                    </label>
                                                                    <label className="radio d-inline-flex">
                                                                        <input {...register('nsfw')} type="radio" className="styled" value="0" defaultChecked={true}/> <span>Safe</span>
                                                                    </label>
                                                                </div>
                                                                </div>
                                                            <div className="col-6">
                                                                <div className="form-group">
                                                                <label>Privacy</label>
                                                                <div className={`form-group ${classes.radio}`}>
                                                                    <label className="radio d-inline-flex">
                                                                        <input {...register('priv')} type="radio" className="styled" value="1" /> <span>Private</span>
                                                                    </label>
                                                                    <label className="radio d-inline-flex">
                                                                        <input {...register('priv')} type="radio" className="styled" value="0" defaultChecked={true} /> <span>Public</span>
                                                                    </label>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className={`form-group mb-0 ${styles.btn_flex}`}>
                                                            <button className='btn btn-primary' type="submit" disabled={ifDisabled}>{ifDisabled ? 'Uploading' : 'Upload'}</button>
                                                            {
                                                                ifDisabled && <Loader />
                                                            }
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="col-4">
                                                    <div className={`${classes.music_thumb} mt-4 pt-2 mb-3`}>
                                                        <img width="100%" src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label> Video Thumbnails(350px X 250px)</label>
                                                        <input {...register('play-img')} onChange={onImageChange}  className="form-control" type="file" accept="image/*" />
                                                    </div>
                                                </div>
                                            </div>
                                            :   <div className='mt-4'>
                                                    <div className={`alert alert-${isSubmitted.type}`} role="alert">{isSubmitted.message}</div>
                                                    {
                                                        isSubmitted.type === 'success' && <div className="align-center" align="center">
                                                            <Link to="/dashboard/musics" className="btn btn-primary">Manage media.</Link>
                                                        </div>
                                                    }
                                                </div>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Suspense>
            </div>
        </>
    )
}

export default AddMusic